import React, { ReactNode } from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../hooks/useAppStore';
import { getManagerPermissions, getEmployeePermissions } from '../store/settings/selectors';
import { usePermissions } from '../hooks/useCommon';
import { getAuthenticateUser } from '../store/authenticate/selectors';
import permissionImg from '../assets/permission.png';

interface PermissionRouteProps {
  children: ReactNode;
  permissionKey: string;
  requiredPermission?: string;
  perform: string
}

const RoleProtectedRoute: React.FC<PermissionRouteProps> = ({
  perform,
  children,
  permissionKey,
  requiredPermission = 'view',
}) => {
  const { permissions } = usePermissions();
  const managerPermissions = useAppSelector(getManagerPermissions) as any;
  const employeePermissions = useAppSelector(getEmployeePermissions) as any;
  const { personnel } = useAppSelector(getAuthenticateUser);
  const { t } = useTranslation('common');

  if (permissions.isAdmin) return children;

  let hasAccess = false;

  if (personnel?.permissionLevel === 'Manager') {
    hasAccess = managerPermissions?.[perform]?.[permissionKey]?.[requiredPermission] || false;
  } else if (personnel?.permissionLevel === 'Employee') {
    hasAccess = employeePermissions?.[perform]?.[permissionKey]?.[requiredPermission] || false;
  }

  return hasAccess ? children : (
    <Container sx={{
      pt: 3,
    }}
    >
      <Box sx={{ maxWidth: 480, margin: 'auto' }} />
      <Typography textAlign="center" variant="h3">
        {t('permissionDenied')}
      </Typography>
      <Typography textAlign="center" sx={{ color: 'text.secondary' }}>
        {t('permissionDeniedText')}
      </Typography>
      <Box display="flex" justifyContent="center">
        <img src={permissionImg} height={400} alt="error" />
      </Box>
    </Container>
  );
};

export { RoleProtectedRoute };
